import { addressInputStyle, inputStyle } from "./styles"
import { jobsCategory } from "../../../helpers/jobs-category"
import occupation from "../../../helpers/occupation"

const fields: FieldPersonalInfo[] = [
  {
    name: "dni",
    label: "Nº ID/ RUT/ Pasaporte",
    placeholder: "ejem (12345678-9)",
    type: "text",
    style: inputStyle,
  },
  {
    name: "residenceCountry",
    label: "País de residencia",
    placeholder: "Seleccionar país",
    style: inputStyle,
    type: "country",
    width: 219,
  },
  {
    name: "address",
    label: "Dirección",
    placeholder: "Calle y número",
    type: "maps",
    id: "inputAddress",
  },
  {
    name: "addressExtension",
    label: "Block/Depto/Casa (opcional)",
    style: addressInputStyle,
    type: "text",
  },
  {
    name: "job",
    label: "Área de trabajo",
    placeholder: "Agricultura",
    type: "select",
    width: 219,
    listOptions: jobsCategory,
  },
  {
    name: "occupation",
    label: "Profesión / ocupación / oficio",
    placeholder: "Gerente",
    type: "select",
    width: 219,
    listOptions: occupation,
  },
  {
    name: "useTaxAddress",
    type: "taxAddress",
    label: "Dirección fiscal",
  },
]

export default fields
